import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react/components/shared/Icon";
import { TippyV2 } from "@circle-react/components/shared/TippyV2";

export const CloseButton = ({
  onRemove,
}: {
  onRemove: (e: React.MouseEvent<HTMLButtonElement>) => void;
}) => (
  <button
    type="button"
    className="text-default bg-primary group absolute -right-3 -top-3 hidden cursor-pointer items-center justify-center rounded-full group-hover:flex"
    onClick={onRemove}
    aria-label={t("tiptap.attachment_previews.remove_link_preview")}
  >
    <TippyV2 content={t("tiptap.attachment_previews.remove_link_preview")}>
      <Icon
        type="16-close-rounded"
        aria-hidden
        size={16}
        className="m-1 !h-4 !w-4"
      />
    </TippyV2>
  </button>
);
